module.exports = __webpack_public_path__ + "static/media/20ECE20.e0bcdc8b.jpg";